import React from 'react';
type LogoProps = {
  tone?: 'light' | 'dark';
};
export function Logo({
  tone = 'dark'
}: LogoProps) {
  const leaf = tone === 'light' ? '#FFFFFF' : '#14402F';
  const center = tone === 'light' ? '#8EEBC1' : '#6F9A82';
  return <span className="flex items-center gap-2.5" aria-label="AVEGA" data-id="element-143" data-mp="3qb5vkobjolk8">
      <svg viewBox="0 0 24 24" className="h-7 w-7" aria-hidden="true" data-id="element-144" data-mp="3v7wc1cr9hj66">
        <path d="M12 1.5C15.2 5.5 15.2 10.5 12 14.5C8.8 10.5 8.8 5.5 12 1.5Z" fill={center} data-id="element-145" data-mp="msupy5esjzdt" />
        <path d="M1.5 8.5C6.8 8.6 10.6 11.2 11.6 16C6.4 15.9 2.6 13.4 1.5 8.5Z" fill={leaf} data-id="element-146" data-mp="rrxl8y4yyr8l" />
        <path d="M22.5 8.5C17.2 8.6 13.4 11.2 12.4 16C17.6 15.9 21.4 13.4 22.5 8.5Z" fill={leaf} data-id="element-147" data-mp="rpl4upev0oxn" />
        <rect x="11.4" y="14" width="1.2" height="8.5" rx="0.6" fill={center} data-id="element-148" data-mp="duiplbo4hn86" />
      </svg>
      <span className={`font-display text-lg font-semibold tracking-[0.28em] ${tone === 'light' ? 'text-white' : 'text-forest'}`} data-id="element-149" data-mp="hvujhte14um6">
        AVEGA
      </span>
    </span>;
}